import { render, staticRenderFns } from "./orderChat.vue?vue&type=template&id=8a6312f8&scoped=true"
import script from "./orderChat.vue?vue&type=script&lang=js"
export * from "./orderChat.vue?vue&type=script&lang=js"
import style0 from "./orderChat.vue?vue&type=style&index=0&id=8a6312f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6312f8",
  null
  
)

export default component.exports